<div class="user-detail-page">
<div class="user-detail">
  <!-- Breadcrumb Navigation and header-->
  <div class="breadcrumb-container">
    <app-user-header 
      [userName]="userName"
      [totalAssignments]="totalAssignments"
      [certifiedAssignments]="certifiedAssignments"
      [totalCertificationAssignments]="totalCertificationAssignments"
      [totalSessions]="totalSessions"
      [hoursSpentPracticing]="hoursSpentPracticing"
      [lastLogin]="lastLogin"
      [memberOfTeams]="memberOfTeams"
      [isLoading]="isLoading">
    </app-user-header>
  </div>
</div>

<div class="user-detail-content-wrapper">
  <qai-inner-wrap>
    <div class="user-detail-content">
      @if (showHighlightCards) {
        <app-user-highlight-cards></app-user-highlight-cards>
      }

      <app-user-assignments (tabChange)="onTabChangedFromUserAssignments($event)"></app-user-assignments>

      <app-user-sessions [totalSessionsCount]="totalSessions" [userName]="userName" [userUuid]="userUuid" [currentTab]="activeTab"></app-user-sessions>
    </div>
  </qai-inner-wrap>
</div>
</div>
